@if (isLoading$ | async) {
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
}
<router-outlet></router-outlet>
